document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector("form#create_customer input[type=password]");
  if (passwordInput) {
    let passwordDiv = null;
    if (passwordInput.parentElement.parentElement.nodeName == "FORM") {
      passwordDiv = passwordInput.parentElement;
    }
    else if (passwordInput.parentElement.parentElement.parentElement.nodeName == "FORM") {
      passwordDiv = passwordInput.parentElement.parentElement;
    }
    else if (passwordInput.parentElement.parentElement.parentElement.parentElement.nodeName == "FORM") {
      passwordDiv = passwordInput.parentElement.parentElement.parentElement;
    }
    const div = document.createElement("div");
    div.setAttribute("class", "field utm-field");
    passwordDiv.before(div);
    const label = document.createElement("label");
    label.innerHTML = storeCodeLocale;
    const utmSource = document.createElement("input");
    utmSource.setAttribute("type", "hidden");
    utmSource.setAttribute("name", "customer[note][utm_source]");
    const utmMedium = document.createElement("input");
    utmMedium.setAttribute("type", "hidden");
    utmMedium.setAttribute("name", "customer[note][utm_medium]");
    const utmContent = document.createElement("input");
    utmContent.setAttribute("type", "hidden");
    utmContent.setAttribute("name", "customer[note][utm_content]");
    const utmContentText = document.createElement("input");
    utmContentText.setAttribute("type", "text");
    utmContentText.setAttribute("placeholder", storeCodeLocale);
    utmContentText.setAttribute("disabled", "disabled");
    utmContentText.setAttribute("readonly", "readonly");
    div.appendChild(label);
    div.appendChild(utmSource);
    div.appendChild(utmMedium);
    div.appendChild(utmContent);
    div.appendChild(utmContentText);
    
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("utm_source")) { 
      utmSource.value = searchParams.get("utm_source");
      if (searchParams.get("utm_source") != "Store" && searchParams.get("utm_source") != "store") {
        div.style.display = "none";
      }
    }
    else {
      div.style.display = "none";
    }
    if (searchParams.has("utm_medium")) { 
      utmMedium.value = searchParams.get("utm_medium");
    }
    if (searchParams.has("utm_content")) { 
      utmContent.value = searchParams.get("utm_content");
      utmContentText.value = searchParams.get("utm_content");
    }
    else {
      div.style.display = "none";
    }
  }
});
